import { APP_TYPES } from '@/comp/AppType'
import { DEFAULT_DEVELOPMENT_AUTH_PASSWORD } from '@/config/developmentAuth.constants'
import { isLocalProductionMode, isLocalRuntime } from '@/utils/environment'

const TEST_AUTH_CREDENTIALS = Object.freeze({
  [APP_TYPES.KIDS]: Object.freeze({
    email: 'test.kloki@seznam.cz',
    password: DEFAULT_DEVELOPMENT_AUTH_PASSWORD
  }),
  [APP_TYPES.GUARDIAN]: Object.freeze({
    email: 'test.guard@seznam.cz',
    password: DEFAULT_DEVELOPMENT_AUTH_PASSWORD
  }),
  [APP_TYPES.PETS]: Object.freeze({
    email: 'test.pets@seznam.cz',
    password: DEFAULT_DEVELOPMENT_AUTH_PASSWORD
  })
})

const LOCAL_PRODUCTION_AUTH_CREDENTIALS = Object.freeze({
  [APP_TYPES.KIDS]: Object.freeze({
    email: 'prod.kids@seznam.cz',
    password: DEFAULT_DEVELOPMENT_AUTH_PASSWORD
  }),
  [APP_TYPES.GUARDIAN]: Object.freeze({
    email: 'prod.guard@seznam.cz',
    password: DEFAULT_DEVELOPMENT_AUTH_PASSWORD
  }),
  [APP_TYPES.PETS]: Object.freeze({
    email: 'prod.pets@seznam.cz',
    password: DEFAULT_DEVELOPMENT_AUTH_PASSWORD
  })
})

const getPrefilledCredentialsMap = () => {
  if (!isLocalRuntime()) return null

  return isLocalProductionMode() ? LOCAL_PRODUCTION_AUTH_CREDENTIALS : TEST_AUTH_CREDENTIALS
}

export const getPrefilledAuthCredentials = (currentAppType) => {
  const credentialsMap = getPrefilledCredentialsMap()

  if (!credentialsMap) return null

  return credentialsMap[currentAppType] || credentialsMap[APP_TYPES.KIDS]
}
